import Backbone from 'backbone'
import _ from 'underscore'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
import ContentHeaderViewTemplate from '../templates/content-header.tpl'
import config from '../config'

const ContentHeaderView = Backbone.View.extend({
    tagName: 'div',
    id: 'content-header-view',
    events: {
        'click .test': 'openTest',
        'click .print': 'openPrint',
        'click .exit': 'exitTest',
        'click .menu': 'openMenu',
    },
    initialize() {
        this.template = _.template(ContentHeaderViewTemplate)
        this.listenTo(this.model, 'change', this.render)
        this.listenTo(config, 'change:shortName', this.render)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))
        return this
    },
    openPrint() {
        const slug = config.get('slug')
        const pdf = this.model.get('pdf')
        const pdfUrl = `/data/${slug}/printables/${pdf}`
        if (Capacitor.getPlatform() !== 'web') {
            Browser.open({ url: pdfUrl })
        } else {
            const pdfWindow = window.open('', '_blank')
            pdfWindow.document.write('Loading...')
            fetch(pdfUrl)
                .then(res => res.blob())
                .then(blob => {
                    pdfWindow.location.href = URL.createObjectURL(blob)
                })
        }
    },
    openTest() {
        const image_prefix = this.model.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/test/${image_prefix}`, {trigger: true})
    },
    exitTest() {
        this.model.get('test').reset()
        const image_prefix = this.model.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/content/${image_prefix}`, {trigger: true})
    },
    openMenu() {
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}`, {trigger: true})
    }
})

export default ContentHeaderView
